import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  title: {
    marginBottom: '8px',
    fontSize: theme.size.sm,
    color: '#3C425B'
  },

  input: {
    marginBottom: '16px',
    width: '360px'
  },

  button: {
    alignSelf: 'flex-end',
    width: 'unset',
    fontSize: theme.size.sm
  }
}))

export default useStyles
